export class InputItem {
  companyid: number;
  projectid: number;
  inputId: number;
  inputCode: string;
  description: string;
  unitCode: string;
  taskid: number;
  inputTypeHiring: number;

  public get id(): string {
    return this.companyid + '/' + this.projectid + '/' + this.inputId;
  }

  getFormattedNumber(value: number): string{
    if (!value)
    {
      value = 0.0;
    }
    return value.toLocaleString(navigator.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}
